/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Styles from './DenFraudesBoletoVerdadeiro.css';
import RedButton from '../../atoms/RedButton/RedButton';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import WhiteButton from '@/components/atoms/WhiteButton';

function DenFraudesBoletoVerdadeiro() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="den-fraudes-boleto-verdadeiro">
        <ContainerHome24>
          <div className="boleto-verdadeiro-conteudo">
            <h3 className="boleto-verdadeiro-titulo">
              Saiba se seu <b>boleto é verdadeiro</b>
            </h3>
            <ol>
              <li>Todo boleto emitido pelo Santander começa com 033, confira sempre.</li>
              <li>
                O beneficiário deve ser SANTANDER SOCIEDADE DE CRÉDITO, FINANCIAMENTO E INVESTIMENTO
                S.A.
              </li>
              <li>Confira se o valor é o de sua parcela, desconfie de valores diferentes.</li>
              <li>Confira se consta corretamente o seu nome e cpf no campo pagador.</li>
            </ol>
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width <= 992 && (
                  <picture>
                    <source
                      type="image/svg"
                      srcSet="assets/denuncias-e-fraudes/img-boleto-falso-1-desk_v2.png"
                    />
                    <img
                      src="assets/denuncias-e-fraudes/img-boleto-falso-1-desk_v2.png"
                      alt="imagem boleto falso"
                      className="img-boleto-falso-1"
                    />
                  </picture>
                )}
                {width > 992 && (
                  <picture>
                    <source
                      type="image/svg"
                      srcSet="assets/denuncias-e-fraudes/img-boleto-falso-1-desk_v2.png"
                    />
                    <img
                      src="assets/denuncias-e-fraudes/img-boleto-falso-1-desk_v2.png"
                      alt="imagem de uma fralde de boleto"
                      className="img-boleto-falso-1"
                    />
                  </picture>
                )}
              </>
            )}
          </div>
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width <= 992 && (
                <picture>
                  <source
                    type="image/svg"
                    srcSet="assets/denuncias-e-fraudes/img-boleto-falso-2_v2.svg"
                  />
                  <img
                    src="assets/denuncias-e-fraudes/img-boleto-falso-2_v2.svg"
                    alt="imagem boleto falso"
                    className=""
                  />
                </picture>
              )}
              {width > 992 && (
                <picture>
                  <source
                    type="image/svg"
                    srcSet="assets/denuncias-e-fraudes/img-boleto-falso-2-desk_v2.svg"
                  />
                  <img
                    src="assets/denuncias-e-fraudes/img-boleto-falso-2-desk_v2.svg"
                    alt="imagem boleto falso"
                    className=""
                  />
                </picture>
              )}
            </>
          )}
        </ContainerHome24>
        <img
          src="assets/denuncias-e-fraudes/img-bg-denuncias-e-fraudes.svg"
          className="img-boleto"
          alt="imagem boleto"
        />
        {/*<img src="assets/boleto25/img-dda-desk.png" className="img-dda-desk" alt="" /> */}
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default DenFraudesBoletoVerdadeiro;
